module.exports = __webpack_public_path__ + "img/instagram.73181da.svg";